import { useEffect, useState } from "react";

const themeOptions = [
  { _id: "theme-royal-sapphire", label: "Royal Sapphire" },
  //   { _id: "theme-rose-quartz", label: "Rose Quartz" },
  { _id: "theme-emerald-elegance", label: "Emerald Elegance" },
  { _id: "theme-amethyst-glow", label: "Amethyst Glow" },
  //   { _id: "theme-dark-onyx-noir", label: "Onyx Noir (Dark)" },
];

const useTheme = () => {
  const savedTheme =
    typeof window !== "undefined" ? localStorage.getItem("theme") : null;
  const defaultTheme = savedTheme || themeOptions[0]._id;
  const [selectedTheme, setSelectedTheme] = useState(defaultTheme);

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("theme", selectedTheme);
    }
    document.documentElement.className = selectedTheme;
  }, [selectedTheme]);

  return { selectedTheme, setSelectedTheme, themeOptions };
};

export default useTheme;
